var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.354,
    height: 48.353,
    viewBox: "0 0 48.354 48.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-20.499 -148.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(18.191 146.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M25.052,1.813a23.982,23.982,0,0,0-14.707,6.12c-.333.3.289,1.548-.027,1.866-.354.352-1.64-.228-1.97.143A23.983,23.983,0,0,0,2.332,24.533c-.026.47.905.941.905,1.417s-.932.943-.905,1.417A23.978,23.978,0,0,0,8.4,42.016a5.347,5.347,0,0,0,1.273.791,4.552,4.552,0,0,0,.73,1.211A23.968,23.968,0,0,0,25.05,50.086a3.772,3.772,0,0,0,1.417-.55l.944-22.676L26.485,2.2A4.717,4.717,0,0,0,25.052,1.813Z",
    transform: "translate(0.017 0.016)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M16.518,2.7V44.248s.948,5.866,1.417,5.836a23.983,23.983,0,0,0,14.693-6.106c.333-.3-.279-1.557.043-1.878.349-.35,1.632.236,1.957-.131a23.971,23.971,0,0,0,6.028-14.6c.027-.47-1.848-.943-1.848-1.417s1.875-.948,1.848-1.417A23.97,23.97,0,0,0,34.588,9.88a3.829,3.829,0,0,0-1.424-.6,3.58,3.58,0,0,0-.584-1.4A23.979,23.979,0,0,0,17.935,1.814C17.518,1.79,16.518,2.7,16.518,2.7Z",
    transform: "translate(9.966 0.017)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M13.593,11.027,7.866,5.411c-.333.3-.658.6-.975.917q-.528.531-1.023,1.089l5.72,5.611Z",
    transform: "translate(2.498 2.54)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M15.686,25.473V33.49c.471.027.943.043,1.417.043h0l.944-3.185L17.1,25.475Z",
    transform: "translate(9.383 16.61)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M17.935,25.473H16.518v8.059q.712,0,1.417-.043Z",
    transform: "translate(9.966 16.61)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M15.686,1.833V9.849H17.1l.944-4.57L17.1,1.79S16.157,1.8,15.686,1.833Z",
    transform: "translate(9.383 0)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M17.935,1.833q-.7-.043-1.417-.043V9.849h1.417Z",
    transform: "translate(9.966 0)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M22.629,24.114l5.713,5.63q.5-.452.987-.934.523-.523,1.011-1.075L24.631,22.11Z",
    transform: "translate(14.252 14.252)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M25.992,18h8.017c.027-.47.043-.941.043-1.417s-.015-.946-.043-1.417H25.992Z",
    transform: "translate(16.611 9.382)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M10.367,15.167H2.351c-.026.471-.043.943-.043,1.417s.015.948.043,1.417h8.017Z",
    transform: "translate(0 9.382)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M24.631,13.053,30.3,7.384q-.47-.528-.971-1.031c-.335-.337-.679-.66-1.031-.973l-5.669,5.669Z",
    transform: "translate(14.252 2.518)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M11.568,22.11,5.9,27.779q.47.528.971,1.031c.335.337.681.66,1.033.973l5.669-5.669Z",
    transform: "translate(2.519 14.252)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M23.77,5.694a17.534,17.534,0,1,0-.111,35.068h.111l.946-16.712L23.77,5.694Z",
    transform: "translate(2.716 2.738)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M34.053,23.228A17.552,17.552,0,0,0,16.519,5.694v35.07A17.554,17.554,0,0,0,34.053,23.228Z",
    transform: "translate(9.967 2.738)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background",
    "data-name": "M8s white background",
    transform: "translate(8.324 137.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M44.31,39a5.863,5.863,0,0,0-2.92-3.518c-.244-.14-.46-.328-.755-.541,3.44-1.552,4.142-4.853,2.586-7.5-1.18-2.01-3.369-2.716-5.538-2.926a11.511,11.511,0,0,0-1.329-.051,13.579,13.579,0,0,0-3.416.509,6.623,6.623,0,0,0-3.2,1.994,5.034,5.034,0,0,0,2.1,7.9c-.167.191-.295.448-.5.555a5.376,5.376,0,0,0-3.064,6.549,6.114,6.114,0,0,0,3.368,4.206,9.6,9.6,0,0,0,4.714.967c.281,0,.563-.014.844-.031a7.521,7.521,0,0,0,6.065-2.926A5.559,5.559,0,0,0,44.31,39Zm-5.32,3.544a2.657,2.657,0,0,1-2.018.281c-.124-.037-.232-.069-.332-.092l-.057-.012a.159.159,0,0,0-.043-.008c-.024-.006-.047-.008-.071-.012a.3.3,0,0,0-.045,0c-.022,0-.047,0-.069,0a.5.5,0,0,0-.059,0,.625.625,0,0,0-.087.006c-.033,0-.067.008-.1.016a1.127,1.127,0,0,0-.146.037.045.045,0,0,0-.02.006c-.018.006-.037.012-.057.021-.053.02-.11.044-.171.075a1.763,1.763,0,0,1-2.24-.336,1.724,1.724,0,0,1,.1-2.374c.824-.967,1.711-1.88,2.788-3.048,1.056,1.239,1.945,2.293,2.844,3.339A1.324,1.324,0,0,1,38.99,42.547Zm-.1-11.116c-.09.116-.183.232-.279.346s-.191.224-.289.336c-.594.673-1.258,1.325-1.968,2.081l-.12.128C35.2,33.11,34.251,32.145,33.5,31.049a1.751,1.751,0,0,1,.112-2.421c.735-.7,1.552-.456,2.374-.157l.075.025a1.43,1.43,0,0,0,.165.028.894.894,0,0,0,.13,0l.053,0a.521.521,0,0,0,.075-.012l.045-.012.049-.018a2.1,2.1,0,0,1,2.639.4C40.047,29.861,39.453,30.7,38.89,31.431Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M252.165,127.756c-.09.116-.183.232-.279.346s-.191.224-.289.336c-.594.673-1.258,1.325-1.968,2.081v-5.668l.053,0a.52.52,0,0,0,.075-.012l.045-.012.049-.018a2.1,2.1,0,0,1,2.639.4C253.323,126.187,252.728,127.026,252.165,127.756Z",
    transform: "translate(-213.275 -96.325)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M252.284,368.023a2.657,2.657,0,0,1-2.018.281c-.124-.037-.232-.069-.332-.092-.02,0-.037-.01-.057-.012a.157.157,0,0,0-.043-.008c-.024-.006-.047-.008-.071-.012a.3.3,0,0,0-.045,0c-.022,0-.047,0-.069,0v-5.6c1.056,1.239,1.945,2.293,2.844,3.339A1.325,1.325,0,0,1,252.284,368.023Z",
    transform: "translate(-213.294 -325.476)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M33.63,28.685a1.748,1.748,0,0,0-.112,2.421c.755,1.1,1.707,2.061,2.739,3.274l.12-.128v2.9c-1.076,1.168-1.963,2.081-2.788,3.048a1.724,1.724,0,0,0-.1,2.374,1.757,1.757,0,0,0,2.24.336c.061-.029.118-.053.171-.075.021-.008.037-.015.057-.021a.045.045,0,0,1,.02-.006,1.126,1.126,0,0,1,.146-.037c.035-.008.069-.012.1-.016a.626.626,0,0,1,.087-.006.5.5,0,0,1,.059,0V47.2a9.6,9.6,0,0,1-4.714-.967,6.107,6.107,0,0,1-3.369-4.205,5.373,5.373,0,0,1,3.064-6.549c.205-.106.334-.364.5-.555a5.034,5.034,0,0,1-2.1-7.9,6.623,6.623,0,0,1,3.2-1.994,13.579,13.579,0,0,1,3.416-.509v4.063a.894.894,0,0,1-.13,0,1.43,1.43,0,0,1-.165-.028l-.075-.025C35.183,28.229,34.365,27.985,33.63,28.685Z",
    transform: "translate(-0.02 -0.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M44.31,39a5.863,5.863,0,0,0-2.92-3.518c-.244-.14-.46-.328-.755-.541,3.44-1.552,4.142-4.853,2.586-7.5-1.18-2.01-3.369-2.716-5.538-2.926a11.511,11.511,0,0,0-1.329-.051,13.579,13.579,0,0,0-3.416.509,6.623,6.623,0,0,0-3.2,1.994,5.034,5.034,0,0,0,2.1,7.9c-.167.191-.295.448-.5.555a5.376,5.376,0,0,0-3.064,6.549,6.114,6.114,0,0,0,3.368,4.206,9.6,9.6,0,0,0,4.714.967c.281,0,.563-.014.844-.031a7.521,7.521,0,0,0,6.065-2.926A5.559,5.559,0,0,0,44.31,39Zm-5.32,3.544a2.657,2.657,0,0,1-2.018.281c-.124-.037-.232-.069-.332-.092-.02,0-.037-.01-.057-.012a1.147,1.147,0,0,0-.159-.024c-.022,0-.047,0-.069,0a.872.872,0,0,0-.248.019,1.126,1.126,0,0,0-.146.037.614.614,0,0,0-.1.037,1.352,1.352,0,0,0-.146.063,1.763,1.763,0,0,1-2.24-.336,1.724,1.724,0,0,1,.1-2.374c.824-.967,1.711-1.88,2.788-3.048,1.056,1.239,1.945,2.293,2.844,3.339A1.325,1.325,0,0,1,38.99,42.547Zm-.1-11.116c-.075.1-.149.193-.23.287-.135.165-.275.328-.419.488-.086.1-.171.189-.262.285-.106.116-.216.232-.328.35-.25.262-.509.529-.775.806-.149.155-.3.315-.458.48-.022.022-.043.047-.065.069l-.12.128C35.2,33.111,34.25,32.147,33.5,31.05a1.751,1.751,0,0,1,.112-2.421c.735-.7,1.552-.456,2.374-.157a.956.956,0,0,0,.37.055l.053,0a.56.56,0,0,0,.169-.043,2.1,2.1,0,0,1,2.639.4C40.047,29.861,39.453,30.7,38.89,31.431Z",
    transform: "translate(0 0)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M252.136,127.756c-.075.1-.149.193-.23.287-.135.165-.275.328-.419.488-.086.1-.171.191-.262.285-.106.116-.216.232-.328.35-.25.262-.509.529-.775.806-.149.157-.3.315-.458.48-.022.022-.043.047-.065.07v-5.67l.053,0a.56.56,0,0,0,.169-.043,2.1,2.1,0,0,1,2.639.4C253.294,126.187,252.7,127.026,252.136,127.756Z",
    transform: "translate(-213.246 -96.325)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M252.284,368.023a2.657,2.657,0,0,1-2.018.281c-.124-.037-.232-.069-.332-.092-.02,0-.037-.01-.057-.012a1.139,1.139,0,0,0-.159-.024c-.022,0-.047,0-.069,0v-5.6c1.056,1.239,1.945,2.293,2.844,3.339A1.325,1.325,0,0,1,252.284,368.023Z",
    transform: "translate(-213.294 -325.476)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M164.3,362.57v5.6a.873.873,0,0,0-.248.019.893.893,0,0,0-.146.037.611.611,0,0,0-.1.037,1.357,1.357,0,0,0-.146.063,1.763,1.763,0,0,1-2.24-.336,1.724,1.724,0,0,1,.1-2.374C162.334,364.651,163.221,363.738,164.3,362.57Z",
    transform: "translate(-127.943 -325.476)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M164.853,124.215v5.669l-.12.128c-1.032-1.213-1.984-2.177-2.739-3.274a1.751,1.751,0,0,1,.112-2.421c.735-.7,1.552-.456,2.374-.157A.956.956,0,0,0,164.853,124.215Z",
    transform: "translate(-128.498 -95.688)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M33.63,28.685a1.748,1.748,0,0,0-.112,2.421c.755,1.1,1.707,2.061,2.739,3.274l.12-.128v2.9c-1.076,1.168-1.963,2.081-2.788,3.048a1.724,1.724,0,0,0-.1,2.374,1.757,1.757,0,0,0,2.24.336,1.353,1.353,0,0,1,.146-.063.614.614,0,0,1,.1-.037,1.126,1.126,0,0,1,.146-.037.871.871,0,0,1,.248-.02V47.2a9.6,9.6,0,0,1-4.714-.967,6.107,6.107,0,0,1-3.369-4.205,5.373,5.373,0,0,1,3.064-6.549c.205-.106.334-.364.5-.555a5.034,5.034,0,0,1-2.1-7.9,6.623,6.623,0,0,1,3.2-1.994,13.579,13.579,0,0,1,3.416-.509v4.063a.956.956,0,0,1-.37-.055C35.183,28.229,34.365,27.985,33.63,28.685Z",
    transform: "translate(-0.02 -0.057)",
    fill: "#fdae02"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.e4356957b635e44e16089eb8692466f7.svg";
export { ForwardRef as ReactComponent };